import { render } from "./PayVideoListShell.vue?vue&type=template&id=1dcc2696&scoped=true"
import script from "./PayVideoListShell.vue?vue&type=script&lang=js"
export * from "./PayVideoListShell.vue?vue&type=script&lang=js"

import "./PayVideoListShell.vue?vue&type=style&index=0&id=1dcc2696&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dcc2696"]])

export default __exports__